import React from 'react'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import Card from "../common/Card";
import {COLOR_chart_barra_serie_0} from "../common/CustomTheme/grayyellow/colors";


HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


export default function OSRespostasBarChart(prop) {
    const { series, title, serieTitle } = prop;
    let categories = [];
    let bTotal = [];

    console.log("barchart", series)

    if (series) {
        series.map(i => {
            categories.push(i.resposta);
            bTotal.push(i.contagem);
        })
    }

    const config = {
        chart: {
            type: 'column',
            zoomType: 'x'
        },
        legend: {
            enabled: true
        },
        title: {
            text: title
        },
        xAxis: {
            categories: categories,
            title: {
                text: ''
            }
        },
        plotOptions: {
            pareto: {
                marker: {
                    enabled: false
                }
            },
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    color: 'blue',
                    format: '{point.y:.0f}',
                    rotation: 270
                }
            }
        },
        yAxis: [
            {
                    title: { text: '' }
            },
            {
                title: { text: '' },
                minPadding: 0,
                maxPadding: 0,
                max: 100,
                min: 0,
                opposite: true,
                labels: {
                    format: "{value}%"
                }
            }
        ],
        series: [
            {
                type: 'column',
                name: serieTitle,
                data: bTotal,
                color: COLOR_chart_barra_serie_0
            }
        ]

    };

    return (
        <Card>
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
